
module.exports = require('./Editor').default

// flow-ignore
if (module.hot)
  module.hot.accept('./Editor', () => {
    console.info('Accepted hot module reload in libs/former-ui')
    module.exports = require('./Editor').default
  })
